import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-987e599c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile_register" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Sign Up", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = { class: "signup" }
const _hoisted_6 = { class: "mobile_signup" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile_signup_title" }, "Sign Up", -1))
const _hoisted_8 = { class: "form" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "E-Mail", -1))
const _hoisted_10 = { class: "inputWrapper" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { class: "form" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Password", -1))
const _hoisted_14 = { class: "inputWrapper" }
const _hoisted_15 = { class: "form" }
const _hoisted_16 = { class: "verify_label" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Verify Code", -1))
const _hoisted_18 = {
  key: 1,
  class: "countdown"
}
const _hoisted_19 = { class: "inputWrapper" }
const _hoisted_20 = { class: "form" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, null, -1))
const _hoisted_22 = { class: "inputWrapper" }
const _hoisted_23 = { class: "join" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.store.handleCloseMobile && _ctx.store.handleCloseMobile(...args)))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowLeft)
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.email) = $event)),
              class: "input",
              placeholder: "Please input email"
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.isValidEmail)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.isValidEmail), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_input, {
              type: "password",
              modelValue: _ctx.formData.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
              class: "input",
              placeholder: "Please input password"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            (_ctx.countdown === 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSendCode && _ctx.handleSendCode(...args))),
                  class: "sent"
                }, "Sent"))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, "countdown: " + _toDisplayString(_ctx.countdown), 1))
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.verifyCode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.verifyCode) = $event)),
              class: "input",
              placeholder: "Please input verifyCode"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_el_button, {
                onClick: _ctx.handleSubmit,
                class: "button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Register")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ])
  ]))
}